import apiSlice from "../api/apiSlice";

export const taskApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: () => "/tasks",
    }),
    getTask: builder.query({
      query: (id) => `/tasks/${id}`,
    }),
    addTask: builder.mutation({
      query: (data) => ({
        url: "/tasks",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data: newTask } = await queryFulfilled;

          dispatch(
            apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              draft.push(newTask);
            })
          );
        } catch {}
      },
    }),
    editTask: builder.mutation({
      query: ({ id, data }) => ({
        url: `tasks/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted({id, data}, { dispatch, queryFulfilled }) {
        try { 
            
           
              const { data: updatedTask } = await queryFulfilled 
            // update home page list
            const patchResult = dispatch(
              apiSlice.util.updateQueryData('getTasks', undefined, (draft) => {
                 
                const targetedTask = draft.find((task) => task.id == updatedTask.id);
                // targetedTask.status = updatedTask.status;           
                Object.assign(targetedTask, updatedTask)
              })
            )
          
             dispatch(
                apiSlice.util.updateQueryData('getTask', id, (draft) => {
                    console.log(JSON.stringify(draft))
                    Object.assign(draft, updatedTask)
                })
              )

        } catch {}
      },
    }),
    deleteTask: builder.mutation({
      query: (id) => ({
        url: `/tasks/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        // optimistic update
        const patchResult = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            return draft.filter((task) => task.id != arg);
          })
        );
        // optimistic update

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetTasksQuery,
  useEditTaskMutation,
  useGetTaskQuery,
  useAddTaskMutation,
  useDeleteTaskMutation,
} = taskApi;
